module.exports = __webpack_public_path__ + "img/overview_button.66417339.png";